import { useMemo } from 'react';

import {
  Group,
  GroupProgram,
  ProgramEntity,
  ProgramEntry,
  ProgramItem,
  ProgramType,
} from '../types';
import { getProgramEntry, sortProgramByDate } from '../utils';
import { useProgramEntitiesById, useProgramStoreSync } from './useProgramStore';

function toEntries(
  items: ProgramItem[] | undefined,
  type: ProgramType,
  entitiesById: Record<string, ProgramEntity>,
): ProgramEntry[] {
  return (items || [])
    .map((item) => getProgramEntry(item, type, entitiesById))
    .filter((entry) => entry.label || entry.startDate || entry.day);
}

/** Programme du groupe, résolu et prêt à afficher : démos et conférences séparées */
export function useGroupProgram(group: Pick<Group, 'demos' | 'conferences'>): GroupProgram {
  useProgramStoreSync();
  const entitiesById = useProgramEntitiesById();
  const { demos, conferences } = group;

  return useMemo(
    () => ({
      demos: toEntries(demos, 'demo', entitiesById),
      conferences: sortProgramByDate(toEntries(conferences, 'conference', entitiesById)),
    }),
    [demos, conferences, entitiesById],
  );
}

export default useGroupProgram;
